<mat-icon *ngIf="value" style="color:green;">{{ icon ? icon : 'check'}}</mat-icon>
<mat-icon *ngIf="!value" style="color:red;">{{ icon ? icon : 'close'}}</mat-icon>
